import { render, staticRenderFns } from "./ForwardMessageCard.vue?vue&type=template&id=1364c10c&scoped=true"
import script from "./ForwardMessageCard.vue?vue&type=script&lang=js"
export * from "./ForwardMessageCard.vue?vue&type=script&lang=js"
import style0 from "./ForwardMessageCard.vue?vue&type=style&index=0&id=1364c10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364c10c",
  null
  
)

export default component.exports